import clsx from "clsx";
import { Star } from "src/sections/assets/icons/icons";
import { ProgressBarFill } from "./progress-bar-fill";

export const ProgressBar = ({ count, reviews }) => {
  return (
    <div key={count.rating} className="flex items-center text-sm">
      <dt className="flex-1 flex items-center">
        <p className="w-3 font-medium text-kj-ink">{count.rating}</p>
        <div aria-hidden="true" className="ml-1 flex-1 flex items-center">
          <Star
            className={clsx(
              reviews.length > 0 ? "fill-kj-gold" : "fill-neutral-600",
              "h-6 w-6 flex-shrink-0"
            )}
          />

          <div className="ml-3 relative flex-1">
            <div className="h-3 bg-kj-card border border-kj-line rounded-full" />
            {count.count > 0 ? (
              <ProgressBarFill count={count} reviews={reviews} />
            ) : null}
          </div>
        </div>
      </dt>
      <dd className="ml-3 w-10 text-right tabular-nums text-sm text-kj-ink">
        {Math.round((count.count / reviews.length) * 100) || 0}%
      </dd>
    </div>
  );
};
